module.exports = {"pagination":{}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/aws-sdk/apis/kinesis-video-media-2017-09-30.paginators.json
// module id = 553
// module chunks = 0